module.exports = __webpack_public_path__ + "img/link.9b1c5d79.svg";